import type { World } from '../core/world';
import type { Network } from './network';

/**
 * No-op, client-authoritative network for single-player + bots. The simulation
 * runs entirely in the browser. Everything here is intentionally empty; it
 * exists so the rest of the app already routes through the Network boundary.
 */
export class LocalNetwork implements Network {
  isAuthoritative(): boolean {
    return true;
  }
  async connect(): Promise<void> {
    /* nothing to connect to */
  }
  disconnect(): void {
    /* nothing to disconnect */
  }
  sync(_world: World): void {
    /* client is authoritative; no reconciliation needed */
  }
}
